import { render } from "./ChartIcon.vue?vue&type=template&id=370ec4fe"
import script from "./ChartIcon.vue?vue&type=script&lang=js"
export * from "./ChartIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__